import type { Lang } from '@platform/core/types';

/** Корінь публічного вебсайту (Solutions/Web): VITE_WEBSITE_URL або локальний сервер розробки на порту 8081. */
const WEBSITE_ROOT = ((import.meta.env.VITE_WEBSITE_URL as string | undefined) ?? 'http://localhost:8081/').replace(/\/?$/, '/');

/** Головна сторінка вебсайту мовою інтерфейсу: українська — site/uk/, англійська — site/. */
export const websiteUrl = (lang: Lang, path = ''): string => `${WEBSITE_ROOT}site/${lang === 'uk' ? 'uk/' : ''}${path || 'index.html'}`;
